import React from "react";
import styles from "./styles/BurgerButton.module.css";

const BurgerButton = ({ isOpenMenu, toggleMenu }) => {
    return (
        <div
            // the button is hidden on page mount and appears on media query
            className={`${styles.burger_button_container}  flex-container`}
            // Stop the useClickOutside hook from detecting clicks on the mobile menu icon
            onMouseDown={(event) => event.stopPropagation()}
            onTouchStart={(event) => event.stopPropagation()}
            onClick={toggleMenu}
        >
            <div className={`${styles.burger_container} flex-container`}>
                <div
                    className={`${styles.burger}`}
                    style={{
                        transform: isOpenMenu ? "rotate(45deg)" : "rotate(0)",
                    }}
                />
                <div
                    className={`${styles.burger}`}
                    style={{
                        transform: isOpenMenu
                            ? "translateX(100%)"
                            : "translateX(0)",
                        opacity: isOpenMenu ? 0 : 1,
                    }}
                />
                <div
                    className={`${styles.burger} $`}
                    style={{
                        transform: isOpenMenu ? "rotate(-45deg)" : "rotate(0)",
                    }}
                />
            </div>
        </div>
    );
};

export default BurgerButton;
